import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, first, toObservable } from "keautils";
import { validation, formfields } from "kea-react"

import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { GuiaListMem } from "app/features/general/operativa/items/guias/listados/guias/list/listmem";
import { FiltroConsultaEADComponent } from "./filtro";
import { FiltroConsultaEAD } from "./model";

export interface State {
    filtro: Partial<FiltroConsultaEAD>;
}

function filtroValido(x: FiltroConsultaEAD): boolean {
    return x.idCamionEAD != null;
}

export class ConsultaCamionEAD extends React.PureComponent<{}, State> {
    constructor(props) {
        super(props);
        this.state = {
            filtro: {}
        };
    }

    filtro = (state: State) => state.filtro;
    valido = createSelectorRx(this.filtro, filtroValido);
    guias = createSelectorRx(this.filtro, this.valido, (filtro, valido) => valido ? observeResource(resources.CargaDescargaEAD.GuiasEnCamion, filtro.idCamionEAD) : toObservable([]));

    render() {
        const guias = this.guias(this.state);
        return (
            <div>
                <kea.Title titulo="Consulta de guias en camión de EAD" onRegresar={() => history.go("../")} />
                <FiltroConsultaEADComponent value={this.state.filtro} onChange={x => this.setState({ filtro: x })} />
                <GuiaListMem value={guias} />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/consultaEAD/index.tsx